{
  "errorBoundary": {
    "dashboard": "Le tableau de bord de la boîte à outils n'a pas pu se charger.",
    "extractor": "La vue Extracteur de Modèle n'a pas pu se charger.",
    "extractorRun": "La vue d'exécution de l'Extracteur de Modèle n'a pas pu se charger.",
    "gatekeeper": "La vue Sentinelle n'a pas pu se charger.",
    "gatekeeperRun": "La vue d'exécution de la Sentinelle n'a pas pu se charger.",
    "logicInspector": "La vue Chasseur de défauts n'a pas pu se charger.",
    "logicInspectorRun": "La vue d'exécution du Chasseur de défauts n'a pas pu se charger.",
    "docReviewer": "La vue Inspecteur de documents n'a pas pu se charger.",
    "docReviewerRun": "La vue d'exécution de l'Inspecteur de documents n'a pas pu se charger.",
    "codeWalkthrough": "Échec du chargement de la revue de code.",
    "codeWalkthroughRun": "Échec du chargement de l'exécution."
  },
  "dashboard": {
    "title": "Outils disponibles",
    "empty": "Aucun outil disponible.",
    "loading": "Chargement…",
    "loadFailedFallback": "Échec du chargement des tâches",
    "activeRuns": "Exécutions actives",
    "activeIdle": "inactif",
    "activeRunningSuffix": "en cours · actualisation 4 s",
    "tools": "Outils",
    "toolsAvailableLabel": "disponibles",
    "extractorTileName": "Extracteur de Modèle",
    "extractorTileCap": "Extrait la logique complexe d'un modèle Excel dans un paquet d'actifs — facile à consommer aussi bien par un humain que par un agent IA.",
    "gatekeeperTileName": "Sentinelle",
    "gatekeeperTileCap": "Contrôle d'admission rapide d'un dossier de soumission. Déposez les fichiers (ou un dossier entier), associez-les à une checklist, obtenez un verdict PASS/FAIL et la liste de ce qui manque — avant toute validation approfondie.",
    "lastUsed": "Dernière utilisation",
    "open": "Ouvrir",
    "flawHunterTileName": "Chasseur de défauts",
    "flawHunterTileCap": "Analyse statique du code de modèle pour détecter les anti-patterns d'utilisation des données et de logique — Python / R / SAS / SQL / JS / TS / Java / Go / Rust, etc. Utilisez l'extracteur de modèle pour les modèles Excel.",
    "docInspectorTileName": "Inspecteur de documents",
    "docInspectorTileCap": "Contrôle de cohérence + conformité réglementaire sur la documentation d'un modèle tiers (DOCX / PDF / MD).",
    "recentOutputs": "Sorties récentes",
    "recentMetaSuffix": "toutes vos exécutions · paginé",
    "noCompleted": "Aucune exécution terminée pour le moment. Déposez un classeur dans l'extracteur pour commencer.",
    "nothingRunning": "Rien en cours d'exécution actuellement.",
    "table": {
      "tool": "Outil",
      "target": "Cible",
      "finished": "Terminé",
      "duration": "Durée",
      "output": "Sortie",
      "openArrow": "Ouvrir →"
    },
    "phaseLabel": "Phase",
    "started": "DÉMARRÉ {{time}}",
    "elapsed": "ÉCOULÉ · {{value}}",
    "queued": "en file d'attente",
    "running": "en cours",
    "codeWalkthroughTileName": "Revue de code",
    "codeWalkthroughTileCap": "Classeur de revue ancré à la ligne, à partir du code du modèle"
  },
  "pagination": {
    "showing": "Affichage de <0>{{from}}–{{to}}</0> sur <1>{{total}}</1>",
    "prev": "‹ Préc.",
    "next": "Suiv. ›",
    "loading": "Chargement…",
    "loadFailed": "Échec du chargement des exécutions"
  },
  "extractor": {
    "title": "Extracteur",
    "subtitle": "Extrait des données structurées de classeurs et de documents.",
    "uploadButton": "Importer un fichier",
    "selectFile": "Sélectionnez un fichier pour commencer.",
    "supportedFormats": "Prend en charge XLSX, CSV, PDF, DOCX.",
    "running": "Exécution de l'extracteur...",
    "complete": "Extraction terminée.",
    "failed": "Échec de l'extraction.",
    "downloadResult": "Télécharger le résultat",
    "viewResult": "Voir le résultat",
    "rerun": "Relancer",
    "presetLabel": "2. Choisir un préréglage",
    "pickWorkbookLabel": "1. Choisir le classeur",
    "noPreset": "Aucun préréglage",
    "outputFormat": "Format de sortie",
    "runHistory": "Exécutions récentes",
    "noHistory": "Aucune exécution récente.",
    "openRun": "Ouvrir l'exécution",
    "headline": "Extracteur de Modèle",
    "headlineDescription": "Extrait la logique complexe d'un modèle Excel — formules, VBA, tableaux croisés dynamiques, plages nommées, graphe de dépendances — dans un paquet d'actifs autonome conçu pour être consommé aussi bien par les humains que par les agents IA.",
    "toolbox": "Boîte à outils",
    "runExtraction": "Lancer l'extraction",
    "fileBadge": ".xlsx · .xlsm",
    "presetCustom": "personnalisé (remplacement manuel)",
    "presetActive": "{{name}}",
    "presetButtons": {
      "highLevel": "Haut niveau",
      "highLevelCap": "lecture rapide · détection de motifs activée",
      "balanced": "Équilibré",
      "balancedCap": "valeur par défaut raisonnable · post-traitement léger",
      "detailed": "Détaillé",
      "detailedCap": "approfondi sur la plupart des types · énumération complète"
    },
    "extractionDepth": "3. Régler la profondeur d'extraction",
    "extractionDepthHint": "couche brute toujours sans perte",
    "rows": {
      "vba": "Modules VBA",
      "vbaHelp": "Code source verbatim par module. Standard ajoute un index des procédures. Profond ajoute l'extraction des interactions Range/Cells/Sheets.",
      "pivots": "Tableaux croisés dynamiques",
      "pivotsHelp": "Configuration en Standard. Profond ajoute des dérivations synthétisées par cellule de sortie.",
      "powerQuery": "Power Query (M)",
      "powerQueryHelp": "Source M verbatim par requête. Profond ajoute l'analyse de la chaîne d'étapes.",
      "namedRanges": "Plages nommées",
      "namedRangesHelp": "Léger = nom + refers_to brut. Standard ajoute la liste des cellules résolues. Profond ajoute des enregistrements d'appartenance par cellule.",
      "conditionalFormatting": "Mise en forme conditionnelle",
      "conditionalFormattingHelp": "Règles en Standard. Profond ajoute des enregistrements d'appartenance par cellule.",
      "dataValidation": "Validation des données",
      "dataValidationHelp": "Règles en Standard. Standard inclut déjà des enregistrements d'appartenance par cellule.",
      "charts": "Graphiques",
      "chartsHelp": "Inventaire en Léger. Standard ajoute les liaisons de séries de données.",
      "externalLinks": "Liens externes",
      "externalLinksHelp": "Inventaire en Léger. Standard ajoute des enregistrements consommateur par cellule."
    },
    "postProcessing": "4. Configurer le post-traitement",
    "postProcessingHint": "densité narrative + motifs",
    "aggressiveness": "Agressivité",
    "postHelp": {
      "off": "Le narratif énumère 1:1 à partir du NDJSON brut. Aucun motif. Sans perte.",
      "light": "Les formules identiques contiguës sont regroupées en plages dans le narratif. La couche de motifs n'est pas émise.",
      "standard": "Léger + la détection de motifs WL émet une couche de motifs aux côtés de la couche de cellules.",
      "aggressive": "Standard + les enregistrements narratifs par cellule sont remplacés par des pointeurs « voir motif P-N » lorsque c'est applicable."
    },
    "ctaInfo": "S'exécute dans votre boîte à outils · <0>asynchrone</0> · vous pouvez quitter la page sans risque.",
    "ctaInfoLine2": "La sortie est téléchargée sous forme d'un seul zip via un lien sécurisé à durée de vie courte.",
    "starting": "Démarrage…",
    "runExtractionButton": "Lancer l'extraction",
    "unsupportedFormat": "Format non pris en charge : .{{ext}}. Seuls .xlsx et .xlsm sont acceptés.",
    "whatProduces": "Ce que cela produit",
    "bundleAnatomy": "Anatomie du bundle",
    "fileTreeRoot": "bundle.zip ({jobid}.zip)",
    "fileLabel_one": "{{count}} fichier",
    "fileLabel_other": "{{count}} fichiers",
    "recentRuns": "Exécutions récentes",
    "recentMetaSuffix": "· cet outil seulement · actualisation 4 s",
    "noRecentForTool": "Aucune exécution terminée pour le moment.",
    "tableHeaders": {
      "target": "Cible",
      "finished": "Terminé",
      "duration": "Durée",
      "bundle": "Bundle"
    },
    "tips": "Astuces",
    "tipsItems": {
      "deterministicTitle": "Déterministe",
      "deterministicBody": "Le même classeur produit toujours le même bundle.",
      "formatsTitle": ".xlsx / .xlsm uniquement",
      "formatsBody": "Les anciens <0>.xls</0> / <1>.xlsb</1> et les classeurs protégés par mot de passe lèvent une erreur typée ; retirez d'abord le mot de passe.",
      "rawTitle": "Couche brute toujours sans perte",
      "rawBody": "Le post-traitement ne modifie que les couches narrative et motifs ; les enregistrements au niveau des cellules sont toujours conservés intégralement.",
      "pivotTitle": "Dérivations de tableaux croisés en Profond",
      "pivotBody": "Chaque cellule de sortie d'un tableau croisé devient une expression équivalente à SUMIFS, autonome, en <0>pivots = profond</0>.",
      "scaleTitle": "Des centaines de milliers de cellules sans souci",
      "scaleBody": "Les classeurs volumineux produisent des bundles plus volumineux, téléchargeables sans délai d’expiration."
    },
    "dropZone": {
      "drop": "Déposez un classeur ici",
      "or": "<0>.xlsx</0> ou <1>.xlsm</1> · cliquez pour parcourir",
      "replace": "Remplacer",
      "ready": "prêt à extraire"
    },
    "depthLabels": {
      "off": "Désactivé",
      "light": "Léger",
      "standard": "Standard",
      "deep": "Approfondi",
      "forensic": "Forensique",
      "aggressive": "Agressif"
    },
    "bundleCategories": {
      "index": "Index",
      "corpus": "Corpus (markdown RAG)",
      "archive": "Archive (NDJSON zstd)",
      "narrative": "Markdown narratif",
      "audit": "Audit"
    },
    "anatomy": {
      "workbookOverview": {
        "title": "Vue d'ensemble du classeur",
        "description": "inventaire des feuilles, paramètres de calcul"
      },
      "inputs": {
        "title": "Entrées",
        "description": "cellules feuilles dont dépend le modèle"
      },
      "cycles": {
        "title": "Cycles",
        "description": "dépendances de calcul itératif (si présentes)"
      },
      "namedRanges": {
        "title": "Plages nommées",
        "description": "noms à portée classeur + feuille"
      },
      "tables": {
        "title": "Tableaux",
        "description": "tableaux structurés Excel"
      },
      "formulas": {
        "title": "Formules",
        "description": "ordonnées topologiquement, par feuille"
      },
      "pivots": {
        "title": "Tableaux croisés dynamiques",
        "descriptionConfigs": "configurations",
        "descriptionDeep": "configurations + dérivations aplaties"
      },
      "powerQuery": {
        "title": "Power Query",
        "description": "source M par requête"
      },
      "vba": {
        "title": "VBA",
        "descriptionVerbatim": "modules verbatim",
        "descriptionStandard": "modules + index des procédures",
        "descriptionDeep": "modules + index des procédures + interactions"
      },
      "charts": {
        "title": "Graphiques",
        "descriptionInventory": "inventaire",
        "descriptionSeries": "inventaire + sources des séries"
      },
      "conditionalFormatting": {
        "title": "Mise en forme conditionnelle",
        "descriptionRules": "règles",
        "descriptionDeep": "règles + appartenance par cellule"
      },
      "dataValidation": {
        "title": "Validation des données",
        "description": "règles + appartenance par cellule"
      },
      "externalLinks": {
        "title": "Liens externes",
        "description": "références de classeurs externes"
      },
      "patterns": {
        "title": "Motifs",
        "description": "regroupement de formules par signature WL"
      }
    }
  },
  "extractorRun": {
    "loading": "Chargement de la tâche…",
    "failedToLoad": "Échec du chargement de la tâche",
    "failedToCancel": "Échec de l'annulation de la tâche",
    "cancelling": "Annulation…",
    "cancelRun": "Annuler l'exécution",
    "backToToolbox": "← Retour à la boîte à outils",
    "runAnother": "Lancer une autre →",
    "presetLabel": "préréglage",
    "postLabel": "post",
    "sheetCount": "{{count}} feuilles",
    "pipeline": "Extraction du modèle",
    "statusLabel": "Terminé",
    "starting": "démarrage",
    "failedStatus": "échec",
    "awaitingPlan": "En attente du plan d'exécution…",
    "counters": "Compteurs",
    "runMarkedStaleTitle": "Exécution marquée comme obsolète",
    "runMarkedStaleBody": "Aucun signal de progression n'est parvenu pour cette exécution dans le délai attendu ; elle a donc été clôturée sans résultat. Réessayez.",
    "runCancelled": "Cette exécution a été annulée.",
    "runComplete": "Exécution terminée.",
    "completeStats": {
      "totalTime": "Durée totale",
      "bundle": "Bundle",
      "formulas": "Formules",
      "edges": "Arêtes"
    },
    "bundleContents": "Contenu du bundle",
    "exportToWorkspace": "Exporter vers un workspace",
    "downloadBundle": "Télécharger le bundle",
    "downloadBundleWithSize": "Télécharger le bundle · {{size}} ko",
    "preparing": "Préparation…",
    "runFailedTitle": "Cette extraction n'a pas abouti",
    "runFailedNote": "L'exécution s'est arrêtée avant de produire un ensemble d'actifs ; rien ne peut donc être rapporté sur ce classeur. Relancez l'analyse, et citez l'exécution {{jobId}} si le problème se reproduit.",
    "noDetail": "Aucun détail fourni",
    "manifestNotAvailable": "Manifeste du bundle pas encore disponible — actualisez dans un instant.",
    "headline": "Extracteur de Modèle",
    "stats": {
      "sheet_count": "Feuilles",
      "cell_count": "Cellules",
      "formula_cell_count": "Formules",
      "named_range_count": "Plages nommées",
      "table_count": "Tableaux",
      "pivot_count": "Tableaux croisés",
      "power_query_count": "Power Query",
      "vba_module_count": "Modules VBA",
      "vba_procedure_count": "Procédures VBA",
      "conditional_formatting_rule_count": "Règles MFC",
      "data_validation_rule_count": "Règles VD",
      "chart_count": "Graphiques",
      "chart_series_count": "Séries de graphiques",
      "external_link_count": "Liens externes",
      "graph_node_count": "Nœuds du graphe",
      "graph_edge_count": "Arêtes du graphe",
      "cycle_count": "Cycles",
      "pivot_cell_count": "Dérivations de tableaux croisés",
      "named_range_member_count": "Membres PN",
      "cf_membership_count": "Membres MFC",
      "dv_membership_count": "Membres VD",
      "vba_interaction_count": "Interactions VBA",
      "pattern_count": "Motifs",
      "warning_count": "Avertissements"
    },
    "exportTitleLabel": "Extracteur"
  },
  "gatekeeperRun": {
    "exportTitleLabel": "Sentinelle"
  },
  "common": {
    "loading": "Chargement...",
    "loadFailed": "Chargement impossible.",
    "tryAgain": "Réessayer",
    "attachContextDocument": "Joindre un document de contexte",
    "deleteRun": "Supprimer cette exécution",
    "deleteRunTitle": "Supprimer cette exécution ?",
    "deleteRunBody": "Cela supprime définitivement l'enregistrement d'exécution et tous les artefacts produits (fichier source, sorties, graphiques). Cette action est irréversible.",
    "deleteRunConfirm": "Supprimer",
    "deleteRunDeleting": "Suppression…",
    "deleteRunFailed": "Échec de la suppression",
    "cancel": "Annuler",
    "close": "Fermer",
    "refresh": "Actualiser",
    "running": "En cours",
    "runAnother": "Lancer une autre",
    "runFailed": "Échec de l'exécution",
    "failedChip": "échec",
    "dismiss": "Ignorer",
    "noRunsYet": "Aucune exécution pour le moment",
    "pastRunsHint": "Les exécutions passées apparaîtront ici une fois terminées.",
    "stale": "Périmé",
    "cancelled": "Annulé",
    "interrupted": "Interrompu",
    "runInterruptedTitle": "Exécution interrompue",
    "runInterruptedBody": "Cette exécution s'est arrêtée prématurément car le service qui l'exécutait a été arrêté. Elle n'a produit aucun résultat — lancez une nouvelle exécution pour réessayer.",
    "discard": "Abandonner",
    "downloading": "Téléchargement…",
    "download": "Télécharger",
    "viewFull": "Voir en entier",
    "preparingZip": "Préparation du zip…",
    "loadingJob": "Chargement de la tâche…",
    "loadingJobHint": "Récupération de l'état de la tâche d'inspection.",
    "errorBackToToolbox": "Retour à la boîte à outils",
    "parentModelArchived": "Ce modèle est archivé. Les nouvelles exécutions et les exports vers un projet sont désactivés ; tout ce que ce modèle a déjà produit reste répertorié et téléchargeable.",
    "parentModelMissing": "Ouvrez la boîte à outils depuis un modèle pour lancer une nouvelle exécution."
  },
  "logicInspector": {
    "title": "Chasseur de défauts",
    "subtitle": "Analyse statique des antipatterns d'utilisation des données et de logique dans le code de modèle — Python / R / SAS / SQL / JS / TS / Java / Go / Rust.",
    "intro": "Déposez du code de modèle — Python / R / SAS / SQL / JS / TS / Java / Go / Rust / etc. Les classeurs Excel ne sont pas pris en charge ici ; utilisez d'abord l'outil <strong>Extracteur de Modèle</strong> si votre modèle est sous Excel. Le paquet reste dans votre boîte à outils ; rien n'est importé automatiquement dans un workspace.",
    "stepPickFiles": "1. Choisir les fichiers",
    "filePickerHint": "Tout fichier texte ou code — Python, R, SAS, SQL, JS, TS et plus. Les fichiers Excel passent par l'Extracteur de Modèle.",
    "stepPickCategories": "2. Choisir les catégories",
    "categoriesHint": "Les catégories désactivées ne produisent aucun constat, même si le paquet en contient.",
    "addCustomCheck": "Ajouter un contrôle personnalisé…",
    "customCheckPlaceholder": "ex. « signaler tout modèle qui s'ajuste sans définir random.seed »",
    "submitting": "Envoi…",
    "submittingHint": "Mise en file de la tâche d'inspection.",
    "runCta": "Lancer Chasseur de défauts",
    "recentRuns": "Exécutions récentes",
    "noCompletedRuns": "Aucune exécution terminée pour le moment.",
    "colTarget": "Cible",
    "colFindings": "Constats",
    "colCategories": "Catégories",
    "colFinished": "Terminé",
    "colDuration": "Durée",
    "colStatus": "Statut",
    "huntingFlaws": "Recherche de défauts",
    "huntingFlawsHint": "Statut : {{status}}…",
    "runFailedTitle": "Cette inspection n'a pas abouti",
    "runFailedNote": "L'exécution s'est arrêtée avant de produire des constats ; rien ne peut donc être rapporté sur ce code — pas même qu'il est sain. Relancez l'analyse, et citez l'exécution {{jobId}} si le problème se reproduit.",
    "inspectionComplete": "Inspection terminée",
    "completed": "Terminé",
    "findingsCount_one": "{{count}} constat",
    "findingsCount_other": "{{count}} constats",
    "categoriesEnabled": "{{count}} catégories activées",
    "exportToWorkspace": "Exporter vers un workspace",
    "noFindingsDetected": "Aucun constat détecté."
  },
  "docReviewer": {
    "title": "Inspecteur de documents",
    "subtitle": "Vérification de la cohérence et de la conformité réglementaire d'un seul document de la documentation d'un modèle tiers.",
    "intro": "Importez un artefact de documentation de modèle (.docx · .pdf · .md · .txt · .rst). Le type de document est <strong>facultatif</strong> : choisissez-en un pour ajouter une passe réglementaire limitée aux connaissances curées correspondantes, ou laissez-le vide pour n'exécuter que la passe de qualité rédactionnelle.",
    "stepPickDocument": "1. Choisir le document",
    "filePickerHint": "Document unique — .docx · .pdf · .md · .txt · .rst.",
    "stepPickTemplate": "2. Ajouter un modèle ou des consignes (facultatif)",
    "templateHint": "Importez le modèle, la liste des contenus exigés ou le document de consignes que cette soumission doit respecter — Bennie en dérive une liste d’exigences et évalue le document au regard de celle-ci. Laissez-le vide et <strong>aucune vérification des exigences n’est exécutée</strong> ; le rapport l’indique comme non demandée.",
    "templateFilePickerHint": "Document unique — .docx · .pdf · .md · .txt · .rst.",
    "stepPickDocumentType": "3. Choisir le type de document (facultatif)",
    "documentTypeHint": "Verticale → type de document détermine la documentation de référence utilisée pour la passe réglementaire. Laissez-le vide et <strong>aucune passe réglementaire n’est exécutée</strong> ; le rapport l’indique comme non demandée.",
    "selectScopeCta": "Choisir le type de document",
    "editScope": "Modifier",
    "clearScope": "Effacer",
    "cancelScope": "Annuler",
    "scopeSummary": "Sélectionné : <strong>{{title}}</strong> · Type de document : <strong>{{type}}</strong>",
    "submitting": "Envoi…",
    "submittingHint": "Création de la tâche d'inspection.",
    "runCta": "Lancer Inspecteur de documents",
    "recentRuns": "Exécutions récentes",
    "noCompletedRuns": "Aucune exécution terminée pour le moment.",
    "colDocument": "Document",
    "colMode": "Mode",
    "colFindings": "Constats",
    "colVerdict": "Verdict",
    "colFinished": "Terminé",
    "colStatus": "Statut",
    "modeNoDocumentType": "aucun type de document",
    "modeUnreadable": "illisible",
    "modeUnreadableHint": "Cette exécution a enregistré un résultat au format actuel, mais la section réglementaire est absente ou mal formée : il est donc impossible d'établir si un type de document a été utilisé. Ce n'est pas un résultat conforme.",
    "inspectingDocument": "Inspection du document",
    "runningChecks": "Exécution des contrôles demandés…",
    "reviewComplete": "Examen terminé",
    "completed": "Terminé",
    "runIncomplete": "Examen incomplet",
    "runIncompleteChip": "Non abouti",
    "runIncompleteHeading": "Certains contrôles n'ont pas abouti",
    "runIncompleteNote": "Aucun verdict global n'a été établi pour cette exécution ; elle ne doit donc pas être interprétée comme une réussite. Les contrôles qui ont abouti sont présentés ci-dessous, chacun avec son propre résultat.",
    "runCancelledTitle": "Exécution annulée",
    "runCancelledNote": "Cette exécution a été annulée avant la fin ; aucun examen n'a donc été produit pour ce document.",
    "runStaleTitle": "Exécution marquée obsolète",
    "runStaleNote": "Aucun signal de progression n'est parvenu pour cette exécution dans le délai attendu ; elle a donc été clôturée sans résultat. Soumettez à nouveau le document.",
    "advisoryPassed": "Prêt pour une utilisation en aval.",
    "advisoryPassedWithIssues": "Soumettez ce document à une validation complète avant de vous y fier en aval.",
    "advisoryFailed": "Reprise substantielle nécessaire — relancez l'analyse avant toute utilisation de ce rapport en aval.",
    "advisoryNotRequestedScope": "{{advisory}} Ce verdict ne couvre pas les contrôles non demandés : {{checks}}.",
    "advisoryScopeSeparator": ", ",
    "validateAction": "Valider",
    "downloadReport": "Télécharger le rapport (.docx)",
    "downloadWorkbook": "Télécharger le classeur (.xlsx)",
    "resubmitAction": "Soumettre à nouveau",
    "internalRegulatoryCount": "{{internal}} interne · {{regulatory}} réglementaire",
    "internalCountNoRegulatory": "{{internal}} interne · contrôle réglementaire non demandé",
    "internalInconsistencies": "Incohérences internes",
    "regulatoryNonCompliance": "Non-conformité réglementaire",
    "regulatoryNotRequestedNote": "Non demandé — aucun type de document n'a été sélectionné, le contrôle réglementaire n'a donc pas été exécuté. Ce n'est pas un résultat conforme.",
    "notRequestedChip": "non demandé",
    "noDocumentTypeSelected": "aucun type de document sélectionné",
    "noInternalFindings": "Aucun constat interne.",
    "noRegulatoryFindings": "Aucun constat réglementaire.",
    "runnerFailed": "échec du runner",
    "scope": "portée",
    "writingQualityCheck": "Contrôle de la qualité rédactionnelle",
    "internalRequirementCheck": "Contrôle des exigences internes",
    "scoreOutOf": "{{score}} %",
    "itemScore": "{{score}}/{{weight}}",
    "sectionNotRequested": "Non demandé",
    "sectionNotRequestedNote": "Ce contrôle n'était pas activé pour cette exécution ; il n'a donc pas été effectué. Ce n'est pas un résultat conforme.",
    "requirementNotRequestedNote": "Non demandé — aucun document modèle n'a été téléversé, aucune liste d'exigences n'a donc été dérivée et ce contrôle n'a pas été effectué. Ce n'est pas un résultat conforme.",
    "sectionFailed": "Ce contrôle n'a pas abouti",
    "sectionFailedReason": {
      "checklist_not_derived": "Aucune exigence n'a pu être tirée du modèle que vous avez téléversé ; il n'y avait donc rien à quoi confronter ce document. Téléversez un modèle dont les exigences sont énoncées sous forme de clauses explicites, puis relancez le contrôle.",
      "checklist_too_large": "Le modèle a produit plus d'exigences qu'une seule exécution ne peut confronter à ce document. Restreignez-le aux sections utiles ici, ou répartissez-le sur plusieurs exécutions.",
      "response_incomplete": "Ce contrôle a manqué de place avant d’avoir fini sa lecture ; son résultat n’aurait porté que sur une partie du document et n’a pas été présenté. Essayez un document plus court, ou divisez celui-ci et traitez les parties séparément.",
      "retrieval_unavailable": "Ce contrôle n’a pas pu accéder à la documentation de référence à laquelle il confronte les documents ; il a donc été interrompu. Votre document n’est pas en cause — réessayez dans quelques instants, et citez l’exécution {{jobId}} si le problème persiste.",
      "timed_out": "Ce contrôle n'a pas répondu dans le délai imparti et a été interrompu. Relancez-le ; un document plus court a moins de risques de traîner. Citez l'exécution {{jobId}} si le problème se reproduit.",
      "unknown": "Le contrôle s'est arrêté avant de produire un résultat ; rien ne peut donc être rapporté à son sujet — pas même que ce document est conforme. Relancez l'analyse, et citez l'exécution {{jobId}} si le problème se reproduit."
    },
    "runFailedTitle": "Cette revue n'a pas abouti",
    "runFailedNote": "L'exécution s'est arrêtée avant qu'un seul contrôle ne produise un résultat ; rien ne peut donc être rapporté sur ce document — pas même qu'il est conforme. Relancez l'analyse, et citez l'exécution {{jobId}} si le problème se reproduit.",
    "sectionUnreadable": "Cette section n'a pas pu être lue",
    "sectionUnreadableNote": "L'exécution a enregistré un résultat au format actuel, mais cette section est absente ou mal formée ; rien ne peut donc être rapporté à son sujet. Ce n'est pas un résultat conforme.",
    "failedChip": "échec",
    "unreadableChip": "illisible",
    "itemUnreadable": "Ce critère n'a pas pu être lu",
    "itemUnreadableNote": "Son score, sa pondération ou ses constats sont absents ou mal formés ; rien ne peut donc être rapporté à son sujet. Ce n'est pas un résultat conforme.",
    "noItemFindings": "Aucun constat pour ce critère.",
    "checklistTitle": "Liste d'exigences dérivée",
    "checklistSource": "Dérivée de {{filename}}",
    "checklistWeight": "p{{weight}}",
    "checklistAnchor": "Source dans le modèle : {{sourceRef}}",
    "checklistDerivedBy": "Dérivée par {{model}} · jeu de prompts {{promptSetVersion}} · SHA-256 du modèle {{templateSha256}}",
    "checklistNotRecorded": "non enregistré",
    "checklistSourceUnrecorded": "Le modèle dont cette checklist a été dérivée n'a pas été enregistré. Ce n'est pas un résultat conforme.",
    "checklistEntryUnreadable": "Cette ligne de checklist n'a pas pu être lue",
    "checklistEntryUnreadableNote": "Sa pondération est absente ou mal formée ; elle ne peut donc pas être présentée comme faisant partie du référentiel dérivé, et les pondérations ci-dessus n'en couvrent pas la totalité. Ce n'est pas un résultat conforme.",
    "checklistMissing": "La liste d'exigences dérivée n'a pas été enregistrée",
    "checklistMissingNote": "Ce contrôle a été noté, mais la liste sur laquelle il a été noté n'a pas été enregistrée avec l'exécution ; les critères ne peuvent donc pas être rattachés au modèle.",
    "legacySchemaNote": "Cette exécution est antérieure au format de résultat actuel : elle n'a ni verdict global ni scores de section. Elle est affichée telle qu'elle a été enregistrée.",
    "sectionStatesHint": "Qualité rédactionnelle : {{writing}} · Exigences internes : {{requirement}} · Réglementaire : {{regulatory}}",
    "state_ok": "effectué",
    "state_not_requested": "non demandé",
    "state_failed": "échec",
    "state_unreadable": "illisible",
    "verdictPassed": "Conforme",
    "verdictPassedWithIssues": "Conforme avec réserves",
    "verdictFailed": "Non conforme",
    "verdictWithheld": "aucun verdict",
    "verdictWithheldHint": "Aucun verdict global n'a été enregistré pour cette exécution : elle ne peut donc pas être lue comme conforme. Ouvrez l'exécution pour voir ce que chaque contrôle a rapporté.",
    "verdictUnreadable": "illisible",
    "verdictUnreadableHint": "Cette exécution a enregistré un verdict global sous une forme illisible : rien ne peut donc en être rapporté. Ce n'est pas un résultat conforme.",
    "verdictLegacyHint": "Cette exécution est antérieure au format de résultat actuel : aucun verdict global n'a jamais été calculé pour elle.",
    "resultUnreadable": "Ce résultat n'a pas pu être lu",
    "resultUnreadableNote": "L'exécution s'est déclarée réussie mais a enregistré son résultat dans un format que Bennie ne reconnaît pas ; rien ne peut donc être rapporté sur ce document — pas même qu'il est conforme. Relancez l'analyse, et citez l'exécution {{jobId}} si le problème se reproduit.",
    "verdictNoResultHint": "Cette exécution n'a enregistré aucun résultat ; il n'y a donc aucun verdict global à rapporter.",
    "verdictShapeUnreadableHint": "Cette exécution a enregistré son résultat dans un format illisible : rien ne peut donc en être rapporté. Ce n'est pas un résultat conforme."
  },
  "findingsTable": {
    "searchPlaceholder": "Rechercher description, emplacement, preuves…",
    "findingsCount_one": "{{count}} constat",
    "findingsCount_other": "{{count}} constats",
    "filteredOfTotal": "{{shown}} sur {{total}}",
    "noFindingsMatchFilter": "Aucun constat ne correspond au filtre actuel.",
    "noFindingsDetected": "Aucun constat détecté.",
    "colSeverity": "Sévérité",
    "colCategory": "Catégorie",
    "colLocation": "Emplacement",
    "colDescription": "Description",
    "ariaExpand": "Développer",
    "ariaCollapse": "Réduire",
    "evidenceExcerpt": "Extrait de preuve",
    "citedAuthority": "Autorité citée — {{framework}} {{reference}}",
    "ckRecord": "Enregistrement CK : {{id}}",
    "filterLabel": "Filtrer {{label}}",
    "noValues": "Aucune valeur.",
    "clear": "Effacer",
    "severityVocabularyUnavailable": "Les libellés de sévérité n'ont pas pu être chargés ; les sévérités sont affichées sous leur forme enregistrée."
  },
  "recentJobs": {
    "noRunsYet": "Aucune exécution pour le moment",
    "pastRunsHint": "Les exécutions passées apparaîtront ici une fois terminées."
  },
  "exportModal": {
    "title": "Exporter les données de {{tool}} vers un workspace",
    "intro": "Seuls les workspaces qui acceptent encore des imports apparaîtront ici.",
    "searchPlaceholder": "Rechercher un workspace par nom ou par id",
    "noWorkspacesMatch": "Aucun workspace ne correspond.",
    "unnamed": "(sans nom)",
    "eligibilityOpen": "Ouvert",
    "eligibilityClosed": "Fermé",
    "cancel": "Annuler",
    "refresh": "Actualiser",
    "export": "Exporter",
    "createProject": "Créer un nouveau projet",
    "chooseModel": "Choisir un modèle",
    "createCheckFailed": "Vérification impossible — réessayer",
    "targetsFailed": "Vos workspaces n'ont pas pu être chargés, il n'y a donc pas encore de destination d'export. Réessayez dans un instant.",
    "importFailed": "L'export ne s'est pas terminé, rien n'a donc été envoyé vers ce workspace. Réessayez dans un instant.",
    "ineligibility": {
      "archived": "Ce workspace est archivé ; il ne peut plus recevoir de données.",
      "model_archived": "Le modèle auquel appartient ce workspace est archivé ; il ne peut plus recevoir de données.",
      "no_workflow_state": "Ce workspace n'a pas encore été configuré.",
      "no_approved_plan": "Approuvez d'abord le plan de ce workspace, puis exportez vers celui-ci.",
      "report_generation_started": "La génération du rapport a commencé ; ce workspace n'accepte plus de nouvelles données.",
      "failed_state": "Résolvez d'abord l'étape en échec de ce workspace, puis exportez vers celui-ci.",
      "workspace_busy": "Ce workspace est occupé — attendez la fin de l'étape en cours, puis réessayez.",
      "workspace_terminal": "Ce workspace est marqué comme terminé ; il ne peut donc plus recevoir de nouvelles données.",
      "unknown_workflow_state": "Nous ne parvenons pas à déterminer l'étape à laquelle se trouve ce workspace ; il ne peut donc pas recevoir de nouvelles données.",
      "auditing_import_requires_phase": "Cet espace de travail reçoit les fichiers par phase d'analyse — ajoutez-les depuis son onglet Efficacité de la conception ou Efficacité du fonctionnement.",
      "default": "Ce workspace ne peut pas recevoir de nouvelles données pour le moment."
    }
  },
  "uploadedFilesTree": {
    "header": "Fichiers importés"
  },
  "gatekeeper": {
    "title": "Sentinelle",
    "subtitle": "Contrôle d'admission du dossier de soumission",
    "package": {
      "title": "1. Choisir le dossier de soumission",
      "help": "Intake multi-format — .docx · .xlsx · .pdf · fichiers de code · .txt. Jusqu'à 200 fichiers, 25 Mo au total par soumission. Les fichiers illisibles sont signalés pour révision manuelle.",
      "dropHeadline": "Ajoutez les fichiers de la soumission",
      "filesButton": "Fichiers",
      "folderButton": "Dossier",
      "dropHint": "ou glissez-déposez ici",
      "queueMeta": "{{count}} fichier(s) · {{size}}",
      "clearAll": "Tout retirer",
      "tooManyFiles": "Trop de fichiers (max {{max}}). Retirez-en pour continuer.",
      "totalTooLarge": "Taille totale supérieure à {{max}}. Retirez des fichiers pour continuer.",
      "fileTooLarge": "{{name}} dépasse {{max}}. Retirez-le pour continuer."
    },
    "template": {
      "title": "2. Choisir le modèle de soumission",
      "help": "Liste de contrôle libre décrivant ce que le dossier doit contenir. Collez du texte ou téléversez un fichier dans n'importe quel format que Bennie sait lire.",
      "paste": "Coller le texte",
      "upload": "Téléverser un fichier",
      "pastePlaceholder": "Listez les artefacts et contenus attendus dans le dossier — fichier de modèle, rapport de validation, résultats de tests, notes méthodologiques, etc.",
      "dropLabel": "Cliquez pour choisir un fichier .docx · .pdf · .md · .txt."
    },
    "knobs": {
      "title": "3. Configurer l'exécution",
      "sampling": "Profondeur d'échantillonnage",
      "samplingHelp": "À quelle profondeur chaque fichier est lu",
      "sampling_sparse": "Léger",
      "sampling_balanced": "Équilibré",
      "sampling_dense": "Dense",
      "strictness": "Sévérité du verdict",
      "strictnessHelp": "À quel point l'étape de verdict est exigeante",
      "strictness_loose": "Souple",
      "strictness_balanced": "Équilibré",
      "strictness_strict": "Strict",
      "outputLanguage": "Langue de sortie",
      "outputLanguageHelp": "Langue de l'explication du verdict",
      "lang_en": "Anglais",
      "lang_fr": "Français"
    },
    "runCta": "Lancer le contrôle",
    "submitting": "Envoi…",
    "submittingHint": "Mise en file du contrôle d'admission.",
    "statusLabel": {
      "completed": "Terminé"
    },
    "recent": {
      "title": "Exécutions récentes",
      "metaSuffix": "· cet outil uniquement · actualisation 4 s",
      "empty": "Aucune exécution terminée pour le moment.",
      "headerHeadline": "Exécution",
      "headerFinished": "Terminé",
      "headerVerdict": "Verdict",
      "headerFiles": "Fichiers",
      "headerDuration": "Durée",
      "headerStatus": "Statut"
    },
    "fileLabel_one": "{{count}} fichier",
    "fileLabel_other": "{{count}} fichiers",
    "verdict": {
      "pass": "PASS",
      "fail": "FAIL",
      "error": "Erreur",
      "cancelled": "Annulée",
      "stale": "Périmée",
      "passHeadline": "Le dossier est suffisant pour démarrer le travail.",
      "failHeadline": "Des artefacts critiques manquent — le dossier n'est pas encore prêt."
    },
    "risk": {
      "high": "Risque élevé",
      "medium": "Risque moyen",
      "low": "Risque faible"
    },
    "run": {
      "title": "Exécution du contrôle",
      "inProgress": "En cours",
      "filesProcessed": "Fichiers traités",
      "starting": "Démarrage…",
      "preparing": "Préparation du dossier…",
      "skimProgress": "{{skimmed}} sur {{total}} fichiers analysés",
      "processedSummary": "{{total}} fichiers · {{ok}} lus · {{attention}} à examiner",
      "phaseExtracting": "Lecture des fichiers",
      "phaseSkimming": "Analyse des fichiers",
      "phaseJudging": "Rendu du verdict",
      "verdictPending": {
        "title": "Rendu du verdict…",
        "subtitle": "Comparaison du résumé d'analyse au modèle de soumission."
      },
      "phaseSkimComplete": "Analyse terminée",
      "phaseComplete": "Terminé",
      "statusOk": "OK",
      "statusAttention": "À examiner",
      "statusProcessing": "En cours",
      "statusPending": "En attente",
      "missingTitle": "Manquant dans le dossier",
      "missingEmpty": "Rien ne manque — le dossier couvre entièrement le modèle.",
      "attentionTitle": "Fichiers à examiner manuellement",
      "errorTitle": "L'exécution n'a pas pu se terminer",
      "runFailedTitle": "Ce contrôle d'entrée n'a pas abouti",
      "runFailedNote": "L'exécution s'est arrêtée avant de produire un verdict ; rien ne peut donc être rapporté sur ce dossier — pas même qu'il est complet. Relancez l'analyse, et citez l'exécution {{jobId}} si le problème se reproduit.",
      "cancelledNote": "Cette exécution a été annulée.",
      "runAnother": "Lancer un autre dossier",
      "backToDashboard": "Retour à la boîte à outils",
      "pollFailed": "Impossible de rafraîchir le statut de l'exécution.",
      "statsFiles": "Fichiers",
      "statsOk": "Analysés",
      "statsAttention": "À examiner",
      "completeTitle": "Contrôle terminé",
      "exportToWorkspace": "Exporter vers un workspace"
    }
  },
  "filePicker": {
    "dropFileHere": "Déposez un fichier ici",
    "dropFilesHere": "Déposez des fichiers ici",
    "fileButton": "Fichier",
    "filesButton": "Fichiers"
  },
  "submitError": {
    "tooLarge": "Cette soumission dépasse la limite de téléversement de {{max}} et n'a pas pu être envoyée. Retirez ou divisez les fichiers volumineux, puis réessayez.",
    "fileTooLarge": "{{name}} dépasse la limite de téléversement de {{max}}.",
    "totalTooLarge": "La taille totale dépasse la limite de téléversement de {{max}}. Retirez des fichiers pour continuer.",
    "generic": "Le lancement n'a pas pu démarrer. Veuillez réessayer — si le problème persiste, contactez le support."
  },
  "download": {
    "session": "Votre session a expiré. Reconnectez-vous, puis relancez le téléchargement.",
    "notReady": "Cette exécution n'est pas encore terminée. Attendez la fin, puis téléchargez.",
    "missing": "Aucun fichier à télécharger pour cette exécution.",
    "timeout": "Le téléchargement a été interrompu car il prenait trop de temps. Veuillez réessayer.",
    "failed": "Le téléchargement ne s'est pas terminé. Veuillez réessayer."
  },
  "codeWalkthrough": {
    "exportToWorkspace": "Exporter vers un workspace",
    "title": "Revue de code",
    "subtitle": "Classeur de revue ancré à la ligne",
    "intro": "Produit un classeur Excel où chaque ligne de code est une ligne du tableau, avec une disposition explicite. Ajoutez une version de référence pour examiner les modifications, et un rapport de validation pour reporter ses constats sur les lignes concernées.",
    "stepCurrent": "Code du modèle",
    "currentHint": "Déposez les scripts, ou un dossier. La plomberie de dépôt (.git, .venv) est exclue.",
    "stepBaseline": "Comparer à une version de référence",
    "baselineHint": "La version antérieure des mêmes scripts. Les fichiers correspondants sont comparés automatiquement.",
    "stepReport": "Annoter à partir d'un rapport de validation",
    "reportHint": "Un rapport de validation (.md, .docx, .pdf). Ses points sont reportés sur les lignes concernées.",
    "willProduce": "Produira :",
    "mode": {
      "fullFile": "Interprétation complète de la logique",
      "diff": "Interprétation des modifications (diff)",
      "fullFileWithReport": "Code annoté, fondé sur le rapport",
      "diffWithReport": "Interprétation des modifications, fondée sur le rapport"
    },
    "submitting": "Démarrage de la revue",
    "submittingHint": "Téléversement des fichiers et mise en file d'attente.",
    "runCta": "Générer le classeur",
    "recentRuns": "Exécutions récentes",
    "noCompletedRuns": "Aucune exécution terminée.",
    "colTarget": "Fichiers",
    "colRows": "Lignes",
    "colFinished": "Terminé",
    "colDuration": "Durée",
    "colStatus": "Statut",
    "running": "Génération du classeur",
    "runningHint": "Annotation de chaque fichier ({{status}}).",
    "runFailedTitle": "Cette revue de code n'a pas abouti",
    "runFailedNote": "L'exécution s'est arrêtée avant de produire un classeur ; rien ne peut donc être rapporté sur ces fichiers. Relancez l'analyse, et citez l'exécution {{jobId}} si le problème se reproduit.",
    "workbookReady": "Classeur prêt",
    "complete": "Terminé",
    "completeWithGaps": "Terminé — revue nécessaire",
    "gapsExplainer": "Le classeur a été généré intégralement. Les marques ambre ci-dessus demandent l'œil d'un relecteur avant diffusion.",
    "chipFiles": "{{n}} fichiers",
    "chipRows": "{{n}} lignes",
    "chipTruncated": "{{n}} cellules tronquées",
    "downloadWorkbook": "Télécharger le classeur",
    "preparingDownload": "Préparation…",
    "chipChangedRows_one": "{{count}} ligne modifiée",
    "chipChangedRows_other": "{{count}} lignes modifiées",
    "chipUnannotated_one": "{{count}} ligne modifiée sans disposition",
    "chipUnannotated_other": "{{count}} lignes modifiées sans disposition",
    "chipUnannotatedInterpretation_one": "{{count}} ligne sans disposition",
    "chipUnannotatedInterpretation_other": "{{count}} lignes sans disposition",
    "noBaselineSupplied": "Aucune version de référence n'a été fournie : rien n'a été comparé — chaque ligne a été interprétée seule.",
    "chipUnplaced_one": "{{count}} conclusion du rapport non rattachée au code",
    "chipUnplaced_other": "{{count}} conclusions du rapport non rattachées au code",
    "chipDropped_one": "{{count}} commentaire non plaçable",
    "chipDropped_other": "{{count}} commentaires non plaçables",
    "chipCommentColumns_other": "{{count}} colonnes de commentaires",
    "inputsHeading": "Cette exécution",
    "inputsComparedWith": "comparé à {{file}}",
    "inputsInterpreted": "interprété seul",
    "inputsReport": "Rapport de validation",
    "inputsUnmatchedBaselines": "Fichiers de référence auxquels rien n'était associé (ignorés)",
    "mappingHeading": "Comparer avec",
    "mappingHint": "Pré-rempli lorsque les noms se correspondent manifestement — modifiable à volonté. Laissez une ligne vide pour examiner ce fichier seul ; les références auxquelles rien n'est associé sont ignorées.",
    "mappingNone": "— aucune, examiner seul —",
    "mappingWillCompare": "revue des changements",
    "mappingWillInterpret": "interprété seul",
    "mappingAriaFor": "Référence pour {{file}}"
  }
}
